<template>
  <v-layout row wrap justify-center>

    <v-flex xs12 sm7 md4 text-xs-center>
      <!-- Lista de botones -->
      <button-slide-list tabindex="0" id="menu-lista" :aria-label="nombreLista" @currentBot="currentBot" :botsNames="bots"></button-slide-list>
    </v-flex>
    <v-flex xs12 sm5 md6 class="aligner">
      <div tabindex="0" id="contenidos" :aria-label="'Contenido ' + bots[nombreCurrentBot].name" class="unstyled-focus"></div><br>
      <div v-for="(item, index) in bots" :key="'slide-cont'+index" v-if="contenido === (index+1)">
        <slot :name="'cont-'+index"></slot>
      </div>
      <button v-if="!finContenidos" @click="backMenu()" aria-label="Volver a la lista anterior"></button>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  props: {
    bots: {
      type: Array,
      requiere: true
    },
    nombreLista: {
      type: String,
      requiere: true
    }
  },
  data() {
    return {
      finContenidos: false,
      contenido: 0,
      nombreCurrentBot: 0
    };
  },
  methods: {
    currentBot(event) {
      this.nombreCurrentBot = (event - 1);
      this.contenido = event;
      document.getElementById("contenidos").focus();

      var showNext = this.bots.every(elem => {
        return elem.visto === true;
      });
      if (showNext) {
        this.$store.commit("nextShow", true);
      }
      this.finContenidos = showNext;
    },
    backMenu() {
      document.getElementById("bot-slide-" + this.contenido).focus();
    }
  },
};
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// tabsButtonsSlide.vue?8bf366ee